import React from 'react';
import { JiraProjectAri } from '@atlassian/ari/jira/project';
import { fg } from '@atlassian/jira-feature-gating';
import { Redirect, useResource, useRouter } from '@atlassian/jira-router';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { PeriscopeEntry } from './entry';

export const PeriscopePage = () => {
	const cloudId = useCloudId();

	const [{ match }] = useRouter();
	const projectKey = match.params.projectKey ?? '';
	const { data: projectData, loading: projectDataLoading } = useResource(projectContextResource);

	const projectAriString =
		!projectDataLoading && projectData?.projectId && cloudId
			? JiraProjectAri.create({
					projectId: String(projectData.projectId),
					siteId: cloudId,
				}).toString()
			: null;

	if (!fg('jira-periscope-new-page')) {
		return <Redirect to={`/projects/${projectKey}`} />;
	}

	return <PeriscopeEntry projectAriString={projectAriString} cloudId={cloudId} />;
};
